import parse from 'html-react-parser';
import Head from 'next/head';
import { FC } from 'react';

import { InternalLocale } from '@catawiki/locale';
import {
  Assets,
  AssetsTheme,
  fetchSharedHTMLAssetsOnServerSide,
} from '@catawiki/runtime-toolkit';

import DefaultAsset from '../stubs/defaultAsset.json';

export interface LayoutAssets extends Assets {
  error?: unknown;
}

export enum LayoutTheme {
  MARKETING = 'marketing',
  PARTNERSHIP = 'partnership',
}

export const PagesTheme = {
  ...AssetsTheme,
  ...LayoutTheme,
} as const;
export type PagesTheme = (typeof PagesTheme)[keyof typeof PagesTheme];

const assetsThemes: PagesTheme[] = [AssetsTheme.BUYER, AssetsTheme.FOCUSED];

export async function fetchLayoutAssets(
  locale: InternalLocale = InternalLocale.ENGLISH,
  theme: PagesTheme = PagesTheme.BUYER
): Promise<LayoutAssets> {
  const assetsTheme = assetsThemes.includes(theme) ? theme : AssetsTheme.BUYER;
  const assetsData = await fetchSharedHTMLAssetsOnServerSide(
    process.env.CW_API_ENDPOINT ?? '',
    assetsTheme as AssetsTheme,
    {
      locale,
      host: process.env.CW_API_HOST ?? '',
      app: process.env.APP_NAME ?? '',
      authToken: process.env.APP_CW_API_AUTH_TOKEN ?? '',
    }
  );

  if (!assetsData.header) {
    return {
      ...DefaultAsset,
      error: 'Fail to load assets',
    };
  }

  return assetsData;
}

interface LayoutAssetsProps {
  assetsData: LayoutAssets;
}

export const LayoutHeadTags: FC<LayoutAssetsProps> = ({ assetsData }) => (
  <Head>{parse(assetsData.third_party.gtm)}</Head>
);

export const LayoutCssTags: FC<LayoutAssetsProps> = ({ assetsData }) => (
  <>{parse(assetsData.tags.head + assetsData.tags.css)}</>
);

export const LayoutJsTags: FC<LayoutAssetsProps> = ({ assetsData }) => (
  <div
    id="cw-js-container"
    suppressHydrationWarning
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{ __html: assetsData.tags.js }}
  />
);
